import { CostCenter } from '../model/cost-center';
export class CostCenterBuilder {
    static buildCostCenter(data) {
        let costCenter = new CostCenter();
        costCenter.id = data.costcenter_id;
        costCenter.name = data.costcenter_name;
        costCenter.paymentMethodId = data.paymethod_id;
        return costCenter;
    }
    static buildCostCenterPayload(costCenter, newRecord) {
        let payload = {
            costcenter_name: costCenter.name,
            paymethod_id: costCenter.paymentMethodId
        };
        if (!newRecord)
            payload.costcenter_id = costCenter.id;
        return payload;
    }
}
//# sourceMappingURL=cost-center-builder.js.map